import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CurrencyPipe, Location } from "@angular/common";
import { ApiServiceService } from "../../../Services/api-service.service";
import { AuthService } from "../../../Services/auth.service";
import { BsModalService } from "ngx-bootstrap/modal";
import alertify from "alertifyjs";
import { CreateOfficeMailComponent } from "../../Admin/bills/create-office-mail/create-office-mail.component";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { Utils } from "../../../Shared/utils";
import { CreateMdaServiceComponent } from "../create-mda-service/create-mda-service.component";
import { ViewCustomMdaDetailsComponent } from "../view-custom-mda-details/view-custom-mda-details.component";

@Component({
  selector: "app-search-mda-services",
  templateUrl: "./search-mda-services.component.html",
  styleUrls: ["./search-mda-services.component.css"],
  providers: [CurrencyPipe],
})
export class SearchMdaServicesComponent implements OnInit {
  isEmpty: boolean = false;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  details: any;
  isLoading: any;
  isSearching: any;
  count: number = 0;
  pageSize: number = 5;
  searchForm: any = FormGroup;
  showSearch: boolean = false;
  tempRevenueType: string;
  countDetails: any;
  showFilters = false;
  minDate: any;
  lottiePath = "assets/lottie/no-data.json";
  preferredCountries: string[] = ["ng", "us", "gb"];
  countryISO: CountryISO = CountryISO.Nigeria;
  protected readonly SearchCountryField = SearchCountryField;
  numbersOnly = Utils.numberOnly;
  form: FormGroup;
  mdaForm: FormGroup;
  searching: boolean;
  asinForm: FormGroup;
  hasPayerData = false;

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private authService: AuthService,
    private bsModalService: BsModalService,
    private currencyPipe: CurrencyPipe,
  ) {}

  ngOnInit(): void {
    this.search();
    this.initializeForm();
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  search() {
    this.details = [];
    this.countDetails = {};

    var formData: any = new FormData();
    this.isEmpty = false;
    this.isSearching = true;

    this.num = this.page * 5;

    formData.append("offset", this.num);
    
    const mdaId = this.authService.getDept()

    if(mdaId){

      formData.append("mda", mdaId);

    }

    const url = "/assessments/search/mda";

    this.apiService.post(url, formData).subscribe(
      (response) => {
        this.details = response?.results;
        if (this.details.length > 0) {
          this.isLoading = false;
          this.count = Math.ceil(response.total);
          this.isSearching = false;
          this.showFilters = false;
        } else {
          this.isLoading = false;
          this.isSearching = false;
          this.isEmpty = true;
          this.showFilters = false;
        }
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
        this.isSearching = false;
      },
    );
  }

  goBack() {
    this.location.back();
  }

  toggleFilter(): void {
    this.showFilters = !this.showFilters;
  }

  now(): Date {
    return new Date();
  }

  get minDateValue(): any {
    return this.minDate;
  }

  view(d: any){
    const bsModalRef = this.bsModalService.show(ViewCustomMdaDetailsComponent, {

      initialState: {
        id: d?.id,
      },
      class: "modal-lg modal-dialog-centered",
    });
  }

  create(): void {
    const bsModalRef = this.bsModalService.show(CreateMdaServiceComponent, {
      class: "create-mda-modal modal-dialog-centered",
    });

    bsModalRef.content.completed.subscribe((value) => {
      this.search();
    });
  }

  onPasteAmount(
    $event: ClipboardEvent,
    formControlName: string,
    form: FormGroup,
  ): void {
    const pastedText = $event.clipboardData.getData("text");
    $event.preventDefault();
    const value = parseFloat(pastedText.replace(/[^0-9.]/g, ""));
    if (value) {
      form?.get(formControlName)?.patchValue(value.toFixed(2));
    }
  }

  onAmountChange(event: any, formControlName: string, form: FormGroup): void {
    const value = parseFloat(event.target.value.replace(/[^0-9.e+]/gi, ""));
    if (value) {
      form
        ?.get(formControlName)
        ?.patchValue(
          this.currencyPipe.transform(value.toFixed(2), "NGN", "symbol-narrow"),
        );
    }
  }

  initializeForm(): void {
    this.asinForm = this.fb.group({
      asin: [""],
    });
    this.form = this.fb.group({
      name: [""],
      asin: ["", [Validators.required]],
      phoneNumber: [""],
      email: [""],
    });

    this.mdaForm = this.fb.group({
      mda: [""],
      serviceType: [""],
      paymentPeriod: [""],
      transactionAmount: [""],
      transactionDescription: [""],
    });
  }

  verifyAsin(): void {
    this.searching = true;
    this.asinForm.markAllAsTouched();
    if (!this.asinForm.valid || this.asinForm?.get("asin")?.value === "") {
      this.searching = false;
      return;
    }
    this.apiService
      .post_g("/assessments/get/asin?asin=" + this.asinForm?.get("asin")?.value)
      .subscribe({
        next: (res: any) => {
          this.searching = false;
          this.hasPayerData = true;
          if (res) {
            this.form.patchValue({
              name: res?.displayname,
              asin: this.asinForm?.get("asin")?.value,
              phoneNumber: res?.phoneNumber,
              email: res?.email,
            });

            this.disableFormFieldsWithValues(this.form, [
              "name",
              "asin",
              "email",
              "phoneNumber",
            ]);
          }
        },
        error: (err: any) => {
          console.log(err.message);
          this.searching = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Invalid asin details");
          console.log(err);
        },
      });
  }

  disableFormFieldsWithValues(
    form: FormGroup,
    fieldsToDisable: string[],
  ): void {
    fieldsToDisable.forEach((formControlName) => {
      const control = form?.get(formControlName);
      if (control.value) {
        control.disable();
      }
    });
  }
  hasAccess(permissions:string[]){
    return this.authService.hasAnyPermission(permissions)
  }
}
